import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-node-col"
}
const _hoisted_2 = {
  class: "flex-container-row gap10 align-center",
  style: {"padding":"5px"}
}
const _hoisted_3 = { style: {"line-height":"100%"} }
const _hoisted_4 = {
  key: 1,
  class: "flex-node-col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_ctx.isDownloading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.localize('downloading')), 1),
          _createVNode(_component_loader, {
            size: "12px",
            style: {"width":"20px"}
          })
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ]))
}